/* eslint-disable linebreak-style */
/* eslint-disable array-callback-return */
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import s from './ReadMoreLess.scss';

import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

class ReadMoreLess extends React.Component {
  constructor() {
    super();
    this.moreClicked = this.moreClicked.bind(this);
    this.state = {
      moreClick: false,
    };
  }

  stateforGoogleboot() {
    if (navigator.userAgent.toLowerCase().indexOf('googlebot') > -1) {
      return;
    }
    this.setState({ moreClick: true });
  }

  moreClicked = () => {
    const { ga4Params = null, isCalculatorPage } = this.props;
    if (this.state.moreClick) {
      this.setState({ moreClick: false }, () => {
        if (ga4Params) {
          ga4Params.label = 'read_more';
          ga4Params.category = ga4Params?.category
            ? ga4Params?.category
            : 'without_recirculation';
          analyticsWrapper('ga4', ga4Params);
        }
      });
    } else {
      this.setState({ moreClick: true }, () => {
        if (ga4Params) {
          ga4Params.label = 'read_less';
          ga4Params.category = isCalculatorPage
            ? 'read_less_click'
            : ga4Params?.category;
          ga4Params.type = isCalculatorPage ? 'read_less' : ga4Params?.type;
          analyticsWrapper('ga4', ga4Params);
        }
      });
    }
  };

  componentDidMount() {
    this.stateforGoogleboot();
  }

  readMoreLess = () => {
    const {
      information,
      readMoreLengthLimit,
      readMoreOnly,
      link,
      ga4Type,
      index,
    } = this.props;
    const informationWithoutMarkup = information.replace(/<\/?[^>]+(>|$)/g, '');
    const splitVal = informationWithoutMarkup.substr(0, readMoreLengthLimit);
    const characterLength = informationWithoutMarkup.length;
    if (
      characterLength > readMoreLengthLimit &&
      !(navigator.userAgent.toLowerCase().indexOf('googlebot') > -1)
    ) {
      return (
        <div className="readWrap">
          {this.state.moreClick ? (
            <span className="textlist">{`${splitVal}...`}</span>
          ) : (
            <div
              className="textlist"
              dangerouslySetInnerHTML={{ __html: information }}
            />
          )}
          {link && (
            <Link
              className={`${s.moreBtn} more_btn`}
              to={link}
              ga4Data={
                !!ga4Type && [
                  {
                    event: 'user_click',
                    type: ga4Type,
                    label: 'read_more',
                    category: 'with_recirculation',
                    story_no: index,
                  },
                ]
              }
            >
              Read More
            </Link>
          )}
          {!link && (
            <>
              {readMoreOnly && (
                <span
                  className={`${s.moreBtn} more_btn`}
                  onClick={this.moreClicked}
                >
                  {this.state.moreClick ? 'Read More' : null}
                </span>
              )}
              {!readMoreOnly && (
                <span
                  className={`${s.moreBtn} more_btn`}
                  onClick={this.moreClicked}
                >
                  {this.state.moreClick ? 'Read More' : 'Read Less'}
                </span>
              )}
            </>
          )}
        </div>
      );
    }
    return (
      <div className="readWrap">
        <div
          className="textlist"
          dangerouslySetInnerHTML={{ __html: information }}
        />
        {link && (
          <>
            ...
            <Link
              className={`${s.moreBtn} more_btn`}
              to={link}
              ga4Data={
                !!ga4Type && [
                  {
                    event: 'user_click',
                    type: ga4Type,
                    label: 'read_more',
                    category: 'with_recirculation',
                    story_no: index,
                  },
                ]
              }
            >
              Read More
            </Link>
          </>
        )}
      </div>
    );
  };

  render() {
    return this.readMoreLess();
  }
}

ReadMoreLess.propTypes = {
  information: PropTypes.string,
  readMoreLengthLimit: PropTypes.number,
  readMoreOnly: PropTypes.bool,
  ga4Params: PropTypes.objectOf({}),
  link: PropTypes.string,
  ga4Type: PropTypes.string,
  index: PropTypes.number,
  isCalculatorPage: PropTypes.bool,
};

ReadMoreLess.defaultProps = {
  information: '',
  readMoreLengthLimit: 200,
  readMoreOnly: false,
  ga4Params: null,
  link: '',
  ga4Type: '',
  index: 0,
  isCalculatorPage: false,
};

export default ReadMoreLess;
